var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHide = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 487 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7,0c23.6,0,42.7,19.1,42.7,42.7v426.6c0,23.6-19.1,42.7-42.7,42.7S0,492.9,0,469.3V42.7C0.1,19.1,19.2,0,42.7,0z M447.9,298.7H273.8c-0.1,0-0.1,0.1,0,0.1l54.4,54.4c16.5,16.5,17.5,43.3,1.5,60.2c-16.6,17.5-44.2,17.8-61.2,0.8L140.5,286.3 c-16.7-16.7-16.7-43.8,0-60.5L268.4,97.8c16.7-16.7,43.7-16.7,60.4,0l0,0c16.7,16.7,16.7,43.7,0,60.4l-55,54.9v0.1 c58,0.1,115.9,0.1,174,0.2c21.6,0,39.1,17.6,39.1,39.2v6.7C487.1,281,469.5,298.7,447.9,298.7z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hide.7c1a412ef445ea2ff8a9f49190ff1891.svg";